export default __webpack_public_path__ + "img_220720_Body_Positive_Peers_main_sq_fullcolor_rgb.svg";